import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { Button, ButtonStyle, ConfirmModal, DetailCardSection, Modal } from "@prequel/shared-components";

import { useDeleteDestination } from "@/api/import/destinations";
import DangerZone from "@/components/DangerZone";
import { useDestinationContext } from "@/pages/import/DestinationsPage/DestinationPage";

const DestinationAdmin = () => {
  const navigate = useNavigate();
  const { destination } = useDestinationContext();
  const deleteDestination = useDeleteDestination();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const onConfirmDelete = () => {
    setShowDeleteModal(false);
    deleteDestination.mutate(destination.id);
  };

  const dangerZoneActions = useMemo(
    () => [
      {
        label: "Delete destination",
        description:
          "This action cannot be undone. All associated streams must be deleted before this destination can be deleted.",
        buttonText: "Delete destination",
        onClick: () => setShowDeleteModal(true),
      },
    ],
    [],
  );

  return (
    <>
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <ConfirmModal
          title="Delete destination"
          message="Are you sure you want to delete this destination? This action cannot be undone."
          onConfirm={onConfirmDelete}
          confirmButtonText="Delete"
          onCancel={() => setShowDeleteModal(false)}
        />
      </Modal>

      <DetailCardSection title="Edit destination">
        <p className="mb-3 text-sm text-stone-600">
          Update the destination&apos;s endpoint, request template, batched delivery settings, or target schema.
        </p>
        <Button
          text="Edit destination"
          type={ButtonStyle.TERTIARY}
          onClick={() => navigate(`/import/destinations/${destination.id}/edit`)}
        />
      </DetailCardSection>

      <DangerZone actions={dangerZoneActions} type="card" />
    </>
  );
};

export default DestinationAdmin;
